import { Routes, Route, PreloadingStrategy } from '@angular/router';
import { of } from 'rxjs';
import { AuthGuard } from 'modules/shared/guards/auth.guards';
import { EnforcedMFAGuard } from 'modules/shared/guards/enforced-mfa.guard';
import { AdminRoleGuard } from 'modules/shared/guards/admin-role.guards';
import { OnlyAdminRoleGuard } from 'modules/shared/guards/only-admin-role.guards';
import { HandshakesEnabledGuard } from 'modules/handshakes/guards/handshakes-enabled.guard';
import { OpenCorporatesEnabledGuard } from 'modules/opencorporates/opencorporates-enabled.guard';
import { LayoutComponent } from 'modules/core/components/layout/layout.component';
var ɵ0 = function () { return import("./modules/admin/admin.module.ngfactory").then(function (m) { return m.AdminModuleNgFactory; }); }, ɵ1 = function () { return import("./modules/user-guide/user-guide.module.ngfactory").then(function (m) { return m.UserguideModuleNgFactory; }); }, ɵ2 = function () { return import("./modules/customers/customers.module.ngfactory").then(function (m) { return m.CustomersModuleNgFactory; }); }, ɵ3 = { preload: true }, ɵ4 = function () { return import("./modules/dashboard/dashboard.module.ngfactory").then(function (m) { return m.DashboardModuleNgFactory; }); }, ɵ5 = function () { return import("./modules/expiring-documents/expiring-documents.module.ngfactory").then(function (m) { return m.ExpiringDocumentsModuleNgFactory; }); }, ɵ6 = function () { return import("./modules/own-restricted-list/own-restricted-list.module.ngfactory").then(function (m) { return m.OwnRestrictedListModuleNgFactory; }); }, ɵ7 = function () { return import("./modules/account-settings/account-settings.module.ngfactory").then(function (m) { return m.AccountSettingsModuleNgFactory; }); }, ɵ8 = function () { return import("./modules/quick-scan/quick-scan.module.ngfactory").then(function (m) { return m.QuickScanModuleNgFactory; }); }, ɵ9 = function () { return import("./modules/xero/xero.module.ngfactory").then(function (m) { return m.XeroModuleNgFactory; }); }, ɵ10 = function () { return import("./modules/ongoing-due-diligence/ongoing-due-diligence.module.ngfactory").then(function (m) { return m.OngoingDueDiligenceModuleNgFactory; }); }, ɵ11 = function () { return import("./modules/handshakes/handshakes.module.ngfactory").then(function (m) { return m.HandshakesModuleNgFactory; }); }, ɵ12 = function () { return import("./modules/opencorporates/opencorporates.module.ngfactory").then(function (m) { return m.OpenCorporatesModuleNgFactory; }); }, ɵ13 = function () { return import("./modules/periodic-review/periodic-review.module.ngfactory").then(function (m) { return m.PeriodicReviewModuleNgFactory; }); };
var routes = [
    {
        path: '',
        component: LayoutComponent,
        canActivate: [AuthGuard, EnforcedMFAGuard],
        children: [
            {
                path: 'admin',
                loadChildren: ɵ0,
                canActivate: [AdminRoleGuard]
            }, {
                path: 'user-guide',
                loadChildren: ɵ1,
            }, {
                path: 'customers',
                loadChildren: ɵ2,
                data: ɵ3,
                canActivate: [OnlyAdminRoleGuard]
            }, {
                path: 'dashboard',
                loadChildren: ɵ4,
                canActivate: [OnlyAdminRoleGuard]
            }, {
                path: 'expiring-documents',
                loadChildren: ɵ5,
                canActivate: [OnlyAdminRoleGuard]
            }, {
                path: 'own-restricted-list',
                loadChildren: ɵ6,
                canActivate: [OnlyAdminRoleGuard]
            }, {
                path: 'account-settings',
                loadChildren: ɵ7,
            }, {
                path: 'quick-scan',
                loadChildren: ɵ8,
                canActivate: [OnlyAdminRoleGuard]
            }, {
                path: 'xero',
                loadChildren: ɵ9,
                canActivate: [OnlyAdminRoleGuard]
            }, {
                path: 'ongoing-due-diligence',
                loadChildren: ɵ10,
                canActivate: [OnlyAdminRoleGuard]
            }, {
                path: 'handshakes',
                loadChildren: ɵ11,
                canActivate: [OnlyAdminRoleGuard, HandshakesEnabledGuard]
            }, {
                path: 'opencorporates',
                loadChildren: ɵ12,
                canActivate: [OnlyAdminRoleGuard, OpenCorporatesEnabledGuard]
            }, {
                path: 'periodic-review',
                loadChildren: ɵ13,
                canActivate: [OnlyAdminRoleGuard]
            }, {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            }
        ]
    }
];
var CustomPreloadingStrategy = /** @class */ (function () {
    function CustomPreloadingStrategy() {
    }
    CustomPreloadingStrategy.prototype.preload = function (route, load) {
        if (route.data && route.data['preload']) {
            return load();
        }
        else {
            return of(null);
        }
    };
    return CustomPreloadingStrategy;
}());
export { CustomPreloadingStrategy };
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13 };
